<template>
  <ul class="graph-key" :class="{ 'graph-key__flex': flex }">
    <li v-for="item in graphKeyItems" class="graph-key__item">
      <span v-if="item.color" class="graph-key__item-color" :style="{ background: item.color }"></span>
      {{ item.body }}
      <span v-if="item.value" class="graph-key__item-value"> {{ item.value }}</span>
    </li>
  </ul>
</template>

<script>
  export default {
    props: {
      graphKeyItems: {
        type: Array,
        required: true
      },
      flex: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="scss">
  .graph-key {
    list-style: none;
    margin: 0;
    padding: 0;

    &__flex {
      display: flex;
      flex-wrap: wrap;
    }

    &__item {
      padding: rem(1) rem(5);
    }

    &__item-color {
      display: inline-block;
      width: rem(12);
      height: rem(12);
      border-radius: rem(2);
      margin-right: rem(2);
    }

    &__item-value {
      font-weight: bold;
      text-transform: uppercase;
    }
  }
</style>



// WEBPACK FOOTER //
// GraphKey.vue?6a3c6698